<template>
  <div>
    <TopBar :page="topBarData"/>
    <AccountsList />
  </div>
</template>

<script>
import TopBar from "@/components/Layout/TopBar";
import AccountsList from "@/components/Accounts/AccountsList";

import { mapActions } from "vuex";

export default {
  components: {
    TopBar,
    AccountsList
  },
  data() {
    return {
      topBarData: {
        name: 'Billing Accounts',
        type: 'accounts',
        showSearch: true,
        menu: false,
        breadcrumbs: [],
        showBeehiveIcon: false,
      },
    }
  },
  methods: {
    ...mapActions("accounts", ["getRecentEditedAccounts"])
  },
  mounted() {
    this.getRecentEditedAccounts();
  },
  watch: {
    $route() {
      this.getRecentEditedAccounts();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
